import moment from 'moment';

export const formatDate = date => {
  return moment(date).format('DD/MM/YYYY');
};

export const getDateNow = date => {
  return moment(date).valueOf();
};

export const getDate = () => {
  return Date.now();
};
